import Vue from 'vue'
import App from './App.vue'
import './assets/js/jquery-3.5.1.min.js'
import './assets/js/bootstrap.bundle.min.js'
import VueRouter from 'vue-router'
import Routers from './router'
import Meta from 'vue-meta'

// 加载template style
import './assets/app.js'

import vuetify from './plugins/vuetify'

Vue.use(VueRouter)
Vue.use(Meta)

const RouterConfig = {
  mode: 'history',
  redirect: '/',
  routes: Routers,
}

const router = new VueRouter(RouterConfig)

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

Vue.config.productionTip = false


new Vue({
  el: '#app',
  router: router,
  vuetify,
  render: h => h(App)
})
